export default {
  path: '',
  component: () => import('@/views/provider/provider-management/Wrapper.vue'),
  children: [
    {
      path: '/provider/provider-search',
      name: 'ProviderManagementSearch',
      component: () => import('@/views/provider/provider-management/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.providers'],
        },
      },
    },
    {
      path: '/provider/provider-management/:companyId?',
      name: 'ProviderManagement',
      component: () =>
        import('@/views/provider/provider-management/ProviderManagement.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.providers'],
        },
      },
    },
    {
      path: '/provider/provider-contract-document/:companyId/:academicYearId?',
      name: 'ProviderContractDocument',
      component: () =>
        import(
          '@/views/provider/provider-management/ProviderContractDocument.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.providers'],
        },
      },
    },
  ],
};
